import { InputAdornment } from '@mui/material';
import React from 'react';

import { TextField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

interface IWalletAmountInputFieldProps {
  fieldArrayName: string;
  periodLabel?: string;
}

export const WalletAmountInputField = ({
  fieldArrayName,
  periodLabel,
}: IWalletAmountInputFieldProps) => (
  <TextField
    name={`${fieldArrayName}.value`}
    label='Amount'
    type='number'
    InputProps={{
      endAdornment: (
        <InputAdornment position='end'>{`items${periodLabel && ` ${periodLabel}`}`}</InputAdornment>
      ),
    }}
    InputLabelProps={{
      shrink: true,
    }}
    fieldProps={{
      parse: parseNumber,
    }}
  />
);
